import React from 'react';
import { connect } from 'react-redux';

const TicketTotal = ({ticket, onTotalLabelClick}) => {

    const getTicketTotal = () => {
        return ticket ? ticket.totalAmount.toFixed(2) : '';
    }

    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 480;

    const labelStyle = isMobile && onTotalLabelClick
        ? { cursor: 'pointer' }
        : {};

    return (
        <div className="totals">
            <span
                className="ticketTotalLabel"
                onClick={isMobile ? onTotalLabelClick : undefined}
                style={labelStyle}
            >
                Toplam:
            </span>
            <span className="ticketTotal">{getTicketTotal()}</span>
        </div>
    );
}

const mapStateToProps = state => ({
    ticket: state.app.get('ticket')
})

export default connect(
    mapStateToProps
)(TicketTotal)



// WEBPACK FOOTER //
// ./app/components/TicketTotal.jsx